import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50">
      <div className="hidden md:flex items-center justify-between px-6 h-9 bg-foreground-950 text-background-100 text-xs font-label">
        <p className="flex items-center gap-2">
          <i className="ri-lock-2-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          <span>匿名投稿 · 全程保护投稿人身份</span>
        </p>
        <p className="flex items-center gap-3 flex-wrap">
          <span className="flex items-center gap-1.5">
            <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-300 transition-colors cursor-pointer">
              {siteInfo.email}
            </a>
          </span>
          <span className="text-background-400">|</span>
          <span>{siteInfo.workTime}</span>
        </p>
      </div>

      <div
        className={`transition-all duration-300 border-b ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200 shadow-sm"
            : "bg-background-50 border-transparent"
        }`}
      >
        <div className="flex items-center justify-between gap-4 px-4 md:px-6 h-16 md:h-[70px]">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0" aria-label="直曝首页">
            <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl font-bold">
              曝
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold text-foreground-950 tracking-wide">直曝</span>
              <span className="hidden sm:block text-[11px] text-foreground-500 font-label">网络爆料投稿平台</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.href}
                to={link.href}
                end={link.href === "/"}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/submit"
              className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              我要投稿
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav
            className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 animate-fade"
            aria-label="移动端导航"
          >
            <ul className="flex flex-col">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <NavLink
                    to={link.href}
                    end={link.href === "/"}
                    className={({ isActive }) =>
                      `block px-3 py-3 rounded-md text-sm font-label cursor-pointer ${
                        isActive ? "bg-primary-50 text-primary-700" : "text-foreground-800 hover:bg-background-100"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}